import api from './api';
import config from '../config/config';

class AuthService {
  async login(email, password) {
    try {
      const response = await api.post('/api/auth/login', { email, password });
      
      if (response.data && response.data.success && response.data.token && response.data.user) {
        // Store a flat user object with token and all user fields, including profile_image
        const userToStore = {
          ...response.data.user,
          token: response.data.token
        };
        localStorage.setItem('user', JSON.stringify(userToStore));
      }
      
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      
      // Add fallback logic for 502 errors
      if (error.response && error.response.status === 502) {
        return {
          success: false,
          message: 'Server is temporarily unavailable. Please try again later.'
        };
      }
      
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('user');
  }

  async registerUser(userData) {
    try {
      const response = await api.post('/api/auth/register', userData);
      return response.data;
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  }

  async forgotPassword(email) {
    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      console.error('Forgot password error:', error);
      throw error;
    }
  }

  async verifyResetCode(email, code) {
    try {
      const response = await api.post('/api/auth/verify-code', { email, code });
      return response.data;
    } catch (error) {
      console.error('Code verification error:', error);
      throw error;
    }
  }

  async resetPassword(email, code, newPassword) {
    try {
      const response = await api.post('/api/auth/reset-password', 
        { email, code, newPassword }
      );
      return response.data;
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  }

  getAuthHeader() {
    const user = this.getCurrentUser();
    if (user && user.token) {
      return { Authorization: `Bearer ${user.token}` };
    } else {
      return {};
    }
  }
}

// Export methods individually to match the import statements in your components
const authServiceInstance = new AuthService();
export const login = authServiceInstance.login.bind(authServiceInstance);
export const logout = authServiceInstance.logout.bind(authServiceInstance);
export const registerUser = authServiceInstance.registerUser.bind(authServiceInstance);
export const getCurrentUser = authServiceInstance.getCurrentUser.bind(authServiceInstance);
export const forgotPassword = authServiceInstance.forgotPassword.bind(authServiceInstance);
export const verifyResetCode = authServiceInstance.verifyResetCode.bind(authServiceInstance);
export const resetPassword = authServiceInstance.resetPassword.bind(authServiceInstance);
export const getAuthHeader = authServiceInstance.getAuthHeader.bind(authServiceInstance);

// Also export the entire service as default
export default authServiceInstance;
